// const ed2kPrefix = 'ed2k://'
const magnetPrefix = 'magnet:?'

// 定义一个函数，输入一个字符串类型的url，返回一个字符串类型的结果
/**
 * Trims the magnet valid URL by removing unnecessary information.
 * 
 * @param url - The magnet URL to be trimmed.
 * @returns The trimmed magnet URL.
 */
function trimMagnetValidUrl (url: string): string {
  let urlOut: string = url
  const magnetUrlInfo: string = url.substring(magnetPrefix.length)
  const urlInfos: string[] = magnetUrlInfo.split('&')
  for (let i = 0; i < urlInfos.length; ++i) {
    let index: number = urlInfos[i].indexOf('=')
    if (index < 0) {
      continue
    }
    const tag: string = urlInfos[i].substring(0, index)
    if (tag === 'xt' || tag.indexOf('xt.') === 0) {
      const tagValue = 'urn:btih:'
      const tagEnd: string = urlInfos[i].substring(index + 1, index + 1 + tagValue.length)
      if (tagEnd !== tagValue) {
        break
      }
      let base32InfoHash: string = urlInfos[i].substring(index + tagValue.length + 1)
      if (base32InfoHash.length <= 32) {
        break
      }
      let reg = /[0-9,A-Z,a-z]{40}/
      if (reg.test(base32InfoHash)) {
        if (base32InfoHash.length > 40 && base32InfoHash[40] !== '&') {
          base32InfoHash = base32InfoHash.substring(0, 40)
          index = url.indexOf(base32InfoHash)
          if (index >= 0) {
            urlOut = url.substring(0, index + base32InfoHash.length)
          }
        }
        break
      } else {
        reg = /[0-9,A-Z,a-z]{32}/
        if (reg.test(base32InfoHash)) {
          if (base32InfoHash[32] !== '&') {
            base32InfoHash = base32InfoHash.substring(0, 32)
            index = url.indexOf(base32InfoHash)
            if (index >= 0) {
              urlOut = url.substring(0, index + base32InfoHash.length)
            }
          }
          break
        }
      }
    }
  }
  return urlOut
}

/**
 * 对下载链接进行修复，去除可能的多余部分
 * @param url 
 * @returns 
 */
export const fixLink = (url: string) => {
  if (url.indexOf(magnetPrefix) === 0) {
    return trimMagnetValidUrl(url)
  }
  return url
}